import React from 'react'
import { Redirect } from 'react-router'
interface Props {
} 
export default function Dashboard(props: Props) {

    return <Redirect to={"/FestivalManagement"} />

}